module.exports = __webpack_public_path__ + "img/63533B_AA9472_1C1108_9B8C68-256px.57db4130.png";